import { MantineThemeOverride } from '@mantine/core';

export type CodeTheme = NonNullable<MantineThemeOverride['components']>['Code'];

export const Code: CodeTheme = {
  // todo: define
};
